import React, { useEffect, useRef, useState } from "react";
import useRazorpay from "react-razorpay";
import { toast } from "react-toastify";
import * as APPCONFIG from "../config/app-config.js";
import MyYuukke from "../api/MyYuukke";
import ResourceDownloadApi from "../api/ResourceDownloadApi";
import ProfileService from "../api/ProfileService";

const ResourceRazorPay = ({
  email,
  name,
  contactNumber,
  uId = null,
  userId = null,
  amount,
  serviceId,
  auditUUID,
  updatePaymentStatus,
}) => {
  const [Razorpay] = useRazorpay();
  const initialized = useRef(false);
  const noResponse = useRef(true);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      handlePayment();
    }
  }, []);

  const updateErrorStatus = async (order_id, status, message) => {
    try {
      if (!order_id) return;
      await MyYuukke.updateErrorStatus({
        orderId: order_id,
        amount,
        type: "resource_purchase",
        email,
        status,
        errorStatus: message,
      });
      sessionStorage.removeItem("resource_order_id");
    } catch (err) {
      console.error("updateErrorStatus failed:", err);
    }
  };

  const handlePayment = async () => {
    try {
      const body = {
        emailId: email,
        userId,
        amount: amount * 100,
        realAmount: amount,
        type: "resource_purchase",
        serviceId,
        auditUUID: auditUUID,
      };

      const orderResponse = await ProfileService.getOrderInIt(body);
      if (orderResponse.data.message !== "success") {
        throw new Error("Order init failed");
      }

      const { id: order_id, currency } = orderResponse.data.data;
      sessionStorage.setItem("resource_order_id", order_id);

      const options = {
        key: APPCONFIG.razorPayKey,
        amount: (amount * 100).toString(),
        currency,
        name: "Yuukke Global Venture",
        description: "Resource purchase",
        image:
          "https://corporate.yuukke.com/bcav2/auth/image/be6f008b-2fb9-4027-9634-642b614c3607",
        order_id,

        handler: async (response) => {
          if (!noResponse.current) return;
          noResponse.current = false;

          try {
            const confirmRes = await ResourceDownloadApi.confirmResourcePayment({
              orderId: order_id,
              paymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature || null,
              auditUuid: auditUUID,
            });
            if (confirmRes?.data?.status !== 1) {
              console.error("confirmResourcePayment failed:", confirmRes?.data?.message);
              toast.error(
                "Payment received but confirmation failed. Contact support with your payment ID."
              );
            }
          } catch (err) {
            console.error("confirmResourcePayment call failed:", err);
            toast.error(
              "Payment received but confirmation failed. Contact support with your payment ID."
            );
          }

          sessionStorage.removeItem("resource_order_id");
          updatePaymentStatus("success", response.razorpay_payment_id);
        },

        prefill: {
          name,
          email,
          contact: contactNumber,
        },

        notes: {
          address: "Yuukke Global Venture",
        },

        theme: {
          color: "#a00030",
        },

        redirect: true,

        modal: {
          ondismiss: () => {
            noResponse.current = false;
            updateErrorStatus(order_id, "error", "USER-CLOSED");
            updatePaymentStatus("dismiss");
          },
        },
      };

      const rzp = new Razorpay(options);

      rzp.on("payment.failed", () => {
        updateErrorStatus(order_id, "error", "PAYMENT-FAILED");
        updatePaymentStatus("failed");
      });

      rzp.open();
    } catch (err) {
      console.error("handlePayment error:", err);
      toast.error("Something went wrong. Try again!");
    }
  };

  return <></>;
};

export default ResourceRazorPay;